export interface INewbuildingLayoutOffer {
  /** Срок окончания строительства **/
  buildingDeadline?: string | null;
  /** Срок окончания строительства в коротком формате **/
  buildingDeadlineShorten: string;
  /** Статус сравнения оффера  **/
  comparisonStatus?: EComparisonStatus | null;
  /** Описание в формате: 2-комн. · 42,7 м² · 14/21 эт **/
  description: string;
  /** Этаж **/
  floor: string;
  /** Наличие планировки **/
  hasDecoration: boolean;
  /** Находится ли объявка в избранном **/
  isFavorite: boolean;
  /** ID оффера **/
  offerId: number;
  /** Цена в текстовом виде **/
  priceText: string;
  /** Старая цена в текстовом виде **/
  oldPriceText?: string;
  /** Скидка **/
  discountLabel?: string;
  /** Ссылка на объявление **/
  singleOfferUrl: string;
  /** Заголовок **/
  title: string;
  /** Забронировано **/
  isBookedFromDeveloper?: boolean;
}

export enum EComparisonStatus {
  /** Уже добавлено в сравнение **/
  Added = 'added',
  /** Доступно для добавления в сравнение **/
  Available = 'available',
  /** Недоступно для добавления в сравнение **/
  Unavailable = 'unavailable',
}
